// extracted by mini-css-extract-plugin
module.exports = {"logos":"clients-section-module--logos--3hfi1","clientsSection":"clients-section-module--clients-section--1lo73"};